module.exports = __webpack_public_path__ + "static/media/ecosystem.e294135a.png";